import { IssueCaseDoc, IssueSourceType } from '@gooduncles/gu-app-schema';
import { FC, useCallback } from 'react';

import useIssueCasesForCase from 'src/hooks/subscription/useIssueCasesForCase';
import useStoreById from 'src/hooks/swr/useStoreById';
import { useScrollToElement } from 'src/hooks/useScrollToElement';

import columnStyles from 'src/atomic-components/atoms/Column/Column.module.scss';
import IssueColumnHeader from 'src/atomic-components/organisms/IssuePanel/IssueColumnHeader';
import IssueEditSection from 'src/atomic-components/organisms/IssuePanel/IssueEditSection';
import IssueTargetSection from 'src/atomic-components/organisms/IssuePanel/IssueTargetSection';

import classes from './IssueRegister.module.scss';

interface IssueTabContentProps {
  issueCase: IssueCaseDoc;
}

const IssueTabContent: FC<IssueTabContentProps> = ({ issueCase }) => {
  const { store } = useStoreById(issueCase.storeId);
  const issueCases = useIssueCasesForCase(issueCase._id);

  const { containerRef: caseColumnRef, scrollTo: scrollToIssueCase } = useScrollToElement();

  const scrollToCaseCard = useCallback(
    (caseId: string) => {
      scrollToIssueCase(`case-card-${caseId}`);
    },
    [scrollToIssueCase]
  );

  return (
    <div className={classes.tabContent}>
      <div className={columnStyles.column}>
        <IssueColumnHeader tooltip={issueCase.sourceId ?? undefined}>
          이슈 대상: {issueCase.sourceReferenceDate} {issueCase.sourceType === IssueSourceType.ORDER ? '주문' : '이슈'}
        </IssueColumnHeader>
        <IssueTargetSection
          store={store}
          issue={issueCase}
          issueCases={issueCases}
          onIssueCaseClick={scrollToCaseCard}
        />
      </div>
      <IssueEditSection issueCases={issueCases} caseColumnRef={caseColumnRef} />
    </div>
  );
};

export default IssueTabContent;
